"use strict";

import angular from "angular";

export class UnauthorizedDialogCtrl {
    constructor($mdDialog, DSNDialogService, locals) {
        this.$mdDialog = $mdDialog;
        this.DSNDialogService = DSNDialogService;
        this.locals = locals;
    }

    $onInit() {}
}

angular.module("nucont.shared").controller("UnauthorizedDialogCtrl", [
    "$mdDialog",
    "DSNDialogService",
    "locals",
    UnauthorizedDialogCtrl
]);
